import { initCharts } from './charts.js';
import { initTables } from './tables.js';
import { initAlpineData } from './alpine-data.js';
import { revealFlashingElements } from './dom-utils.js';
import { expensesForm, loansForm, incomesForm, validateResetPasswordForm, childrenForm } from './form-handlers.js';

window.initDataTable = function() {
    let table = document.querySelector('.dynamic-table-container table.comparison-payoff-table');
    if (table) {
        new DataTable(table, {
            responsive: true,
            pageLength: 100,
            lengthMenu: [100, { label: 'All', value: -1 }],
            ordering: false,
            createdRow: function (row, data, dataIndex) {
                if ((dataIndex + 1) % 12 === 0) {
                    row.classList.add('highlighted-table-row');
                }
            }
        });

        table.classList.add('fade-in');
    }
}

document.addEventListener('alpine:init', () => {
    initAlpineData();
    initTables();
    initCharts();
});

document.addEventListener('DOMContentLoaded', () => {
    revealFlashingElements();
});

// Make sure to expose any functions that need to be globally accessible
window.expensesForm = expensesForm;
window.loansForm = loansForm;
window.incomesForm = incomesForm;
window.childrenForm = childrenForm;

// Add new event listener for HTMX beforeRequest
document.addEventListener('htmx:beforeRequest', function(event) {
    if (event.target.id === 'reset-password-form') {
        const isValid = validateResetPasswordForm(event.target);
        if (!isValid) {
            event.preventDefault(); // Prevent HTMX request if validation fails
        }
    }
});
